// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"forbidden__wrapper--19L47","large":"forbidden__large--Ezx9z"};